import {createBrowserRouter} from "react-router";
import MainPage from "./pages/MainPage";
import MenuPage from "./pages/MenuPage";
import MenuItemPage from "./pages/MenuItemPage";
import RecommendationPage from "./pages/RecommendationPage";
import OrderPage from "./pages/OrderPage";
import SettingsPage from "./pages/SettingsPage";
import RecommendationItemPage from "./pages/RecommendItemPage";
import PaymentPage from "./pages/PaymentPage";
import ReceiptPage from "./pages/ReceiptPage";
import OrderIdlePage from "./pages/OrderIdlePage";
import ModifierPage from "./pages/ModifierPage";
import AddonPage from "./pages/AddonPage";
import IngredientPage from "./pages/IngredientPage";
import CustomerPage from "./pages/CustomerPage";
import PaymentMethodPage from "./pages/PaymentMethodPage";
import CombinationPage from "./pages/CombinationPage";
import CombinationAddonPage from "./pages/CombinationAddonPage";
import CombinationIngredientPage from "./pages/CombinationIngredientPage";
import CombinationInfoPage from "./pages/CombinationInfoPage";
import CombinationModifierPage from "./pages/CombinationModifierPage";
import TableNumberPage from "./pages/TableNumberPage";
import ScanArticlePage from "./pages/ScanArticlePage";
import HalfAndHalfPage from "./pages/HalfAndHalfPage";
import HalfAndHalfAddonPage from "./pages/HalfAndHalfAddonPage";
import HalfAndHalfIngredientPage from "./pages/HalfAndHalfIngredientPage";
import HalfAndHalfModifierPage from "./pages/HalfAndHalfModifierPage";
import HalfAndHalfInfoPage from "./pages/HalfAndHalfInfoPage";
import AdditionalSellUnitPage from "./pages/AdditionalSellUnitPage";
import HalfAndHalfAdditionalSellUnitPage from "./pages/HalfAndHalfAdditionalSellUnitPage";

const router = createBrowserRouter([
    {path: "/", Component: MainPage},
    {path: "/Settings", Component: SettingsPage},
    {path: "/menu", Component: MenuPage},
    {path: "/menu/:category/:subCategory/:number", Component: MenuItemPage},
    {path: "/recommendations", Component: RecommendationPage},
    {path: "/recommendations/:groupId", Component: RecommendationPage},
    {path: "/recommendations/:groupId/:number", Component: RecommendationItemPage},
    {path: "/order", Component: OrderPage},
    {path: "/payment", Component: PaymentPage},
    {path: "/receipt", Component: ReceiptPage},
    {path: "/orderIdle", Component: OrderIdlePage},
    {path: "/menu/:category/:subCategory/:number/additionalSellUnits", Component: AdditionalSellUnitPage},
    {path: "/menu/:category/:subCategory/:number/modifiers", Component: ModifierPage},
    {path: "/menu/:category/:subCategory/:number/modifiers/:mogifierGroupId", Component: ModifierPage},
    {path: "/menu/:category/:subCategory/:number/addons", Component: AddonPage},
    {path: "/menu/:category/:subCategory/:number/addons/:addonGroupId", Component: AddonPage},
    {path: "/menu/:category/:subCategory/:number/ingredients", Component: IngredientPage},
    {path: "/recommendations/:groupId/:number/modifiers", Component: ModifierPage},
    {path: "/recommendations/:groupId/:number/modifiers/:mogifierGroupId", Component: ModifierPage},
    {path: "/recommendations/:groupId/:number/addons", Component: AddonPage},
    {path: "/recommendations/:groupId/:number/addons/:addonGroupId", Component: AddonPage},
    {path: "/recommendations/:groupId/:number/ingredients", Component: IngredientPage},
    {path: "/customer", Component: CustomerPage},
    {path: "/paymentMethod", Component: PaymentMethodPage},
    {path: "/menu/combination/info", Component: CombinationInfoPage},
    {path: "/menu/combination/:category/:subCategory/:id", Component: CombinationPage},
    {path: "/menu/combination/:category/:subCategory/:id/step/:stepId", Component: CombinationPage},
    {path: "/menu/combination/:category/:subCategory/:id/step/:stepId/:change", Component: CombinationPage},
    {path: "/menu/combination/:category/:subCategory/:id/step/:stepId/article/:articleId/modifiers", Component: CombinationModifierPage},
    {path: "/menu/combination/:category/:subCategory/:id/step/:stepId/article/:articleId/addons", Component: CombinationAddonPage},
    {path: "/menu/combination/:category/:subCategory/:id/step/:stepId/article/:articleId/ingredients", Component: CombinationIngredientPage},
    {path: "/menu/combination/:category/:subCategory/:id/step/:stepId/article/:articleId/modifiers/:change", Component: CombinationModifierPage},
    {path: "/menu/combination/:category/:subCategory/:id/step/:stepId/article/:articleId/addons/:change", Component: CombinationAddonPage},
    {path: "/menu/combination/:category/:subCategory/:id/step/:stepId/article/:articleId/ingredients/:change", Component: CombinationIngredientPage},
    {path: "/menu/halfAndHalf/:categoryId/:subCategoryId", Component: HalfAndHalfPage},
    {path: "/menu/halfAndHalf/:categoryId/:subCategoryId/:articleNumber/additionalSellUnits", Component: HalfAndHalfAdditionalSellUnitPage},
    {path: "/menu/halfAndHalf/:categoryId/:subCategoryId/:articleNumber/modifiers", Component: HalfAndHalfModifierPage},
    {path: "/menu/halfAndHalf/:categoryId/:subCategoryId/:articleNumber/addons", Component: HalfAndHalfAddonPage},
    {path: "/menu/halfAndHalf/:categoryId/:subCategoryId/:articleNumber/ingredients", Component: HalfAndHalfIngredientPage},
    {path: "/menu/halfAndHalf/info", Component: HalfAndHalfInfoPage},
    {path: "/tableNumber", Component: TableNumberPage},
    {path: "/scanArticle", Component: ScanArticlePage},
]);

export default router;
